<template>
  <!-- 外層容器：與 RegisterPage/ContactPage 的3D效果類似 -->
  <div class="change-password-container" ref="changeBlock">
    <!-- 主要卡片：左右分佈 -->
    <div class="change-password-card">
      <!-- 左側：標題/提示/說明 -->
      <div class="change-password-left">
        <h1>修改密碼</h1>
        <p>請輸入您的當前密碼與新密碼，完成後點擊確認修改。</p>
        <!-- 若需要加入插圖可參考 RegisterPage 的做法 -->
      </div>

      <!-- 右側：表單 -->
      <div class="change-password-right form-block">
        <form @submit.prevent="changePassword">
          <div class="form-group">
            <label for="currentPassword">當前密碼</label>
            <input v-model="currentPassword" id="currentPassword" type="password" required placeholder="輸入當前密碼" />
          </div>

          <div class="form-group">
            <label for="newPassword">新密碼</label>
            <input v-model="newPassword" id="newPassword" type="password" required placeholder="設定新密碼" />
          </div>

          <div class="form-group">
            <label for="confirmPassword">確認新密碼</label>
            <input v-model="confirmPassword" id="confirmPassword" type="password" required placeholder="再次輸入新密碼" />
          </div>

          <div v-if="message" class="error-message">{{ message }}</div>

          <button class="btn" :disabled="!isUpdateEnabled()" type="submit">確認修改</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
  name: 'ChangePasswordPage',
  computed: {
    ...mapState(['userProfile']) // 獲取 Vuex 中的 userProfile 狀態
  },
  data() {
    return {
      message: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    };
  },
  watch: {
    currentPassword: 'updateVerificationMessage',
    newPassword: 'updateVerificationMessage',
    confirmPassword: 'updateVerificationMessage'
  },
  methods: {
    isUpdateEnabled() {
      // 1. 當前密碼不可空
      if (this.currentPassword.length === 0) return false;
      // 2. 新密碼不可空
      if (this.newPassword.length === 0) return false;
      // 3. 新密碼需符合格式 (最少6位, 含小寫字母+數字)
      if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.newPassword)) return false;
      // 4. 新密碼 與 確認新密碼 一致
      if (this.newPassword !== this.confirmPassword) return false;

      if (this.currentPassword === this.newPassword) return false;
      return true;
    },
    updateVerificationMessage() {
      if (this.currentPassword.length === 0) {
        this.message = "當前密碼不能為空";
      } else if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.currentPassword)) {
        this.message = "當前密碼必須至少6位且包含一個小寫字母和一個數字";
      } else if (!/^(?=.*[a-z])(?=.*\d).{6,}$/.test(this.newPassword)) {
        this.message = "新密碼必須至少6位且包含一個小寫字母和一個數字";
      } else if (this.newPassword !== this.confirmPassword) {
        this.message = "密碼與確認密碼不匹配。";
      } else if (this.currentPassword === this.newPassword) {
        this.message = "當前密碼與新密碼不允許相同。";
      } else {
        this.message = '';  // 清空消息，表示無錯誤
      }
    },
    async changePassword() {
      try {
        if (this.userProfile.account == null) {
          this.message = "不需要進行更改。";
          return;
        }
        console.log(this.userProfile.account);

        const res = await axios.post('/api/user/updatePassword', {
          account: this.userProfile.account,
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        });
        if (res.data.success) {
          this.currentPassword = '';
          this.newPassword = '';
          this.confirmPassword = '';

          setTimeout(() => {
            this.message = '';
          }, 1000);
          Swal.fire({
            icon: 'success',
            title: '變更成功！',
            text: '密碼修改成功！',
            confirmButtonText: '確定',
            timer: 2000
          });

        } else {
          this.message = res.data.message || '修改失敗。';
        }
      } catch (error) {
        this.message = error.response?.data?.message || '伺服器錯誤，請稍後再試';
      }
    }
  },
  mounted() {
    // IntersectionObserver：整個卡片的淡入 & 3D翻轉一點點
    const container = this.$refs.changeBlock;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('container-visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(container);
  }
};
</script>

<style scoped>
/* 外層容器：與 ContactPage/RegisterPage 相似 3D 效果 */
.change-password-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  /* 3D 初始狀態 */
  opacity: 0;
  transform: translateY(50px) rotateX(8deg);
  transform-origin: top;
  transition: opacity 1.2s ease, transform 1.2s ease;
  perspective: 800px;
  /* 父容器3D視角 */
}

.change-password-container.container-visible {
  opacity: 1;
  transform: translateY(0) rotateX(0);
}

/* 卡片樣式：左右區塊 */
.change-password-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;

  background-color: #f9f9f9;
  /* 淡灰 */
  border-radius: 10px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;

  /* 動畫預設：先淡出下移 */
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.container-visible .change-password-card {
  opacity: 1;
  transform: translateY(0);
}

/* 左/右 */
.change-password-left,
.change-password-right {
  flex: 1;
  min-width: 300px;
}

/* 左側 */
.change-password-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.change-password-left h1 {
  margin-bottom: 10px;
}

.change-password-left p {
  line-height: 1.6;
}

/* 右側表單 */
.change-password-right {
  display: flex;
  flex-direction: column;
}

/* .form-block 可參考 RegisterPage */
.form-block {
  max-width: 400px;
  margin: 0 auto;
  text-align: left;
}

/* 表單 */
.form-group {
  margin-bottom: 1.5em;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* 按鈕 */
.btn {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;
}

.btn:disabled {
  background-color: #388e3c;
  cursor: not-allowed;
}

/* 錯誤訊息 */
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 手機版: 左右改成上下堆疊 */
@media (max-width: 768px) {
  .change-password-card {
    flex-direction: column;
  }
}

/* 文字 */
@media (max-width: 768px) {
  .register-card {
    flex-direction: column;
  }

  h1 {
    font-size: 2.0rem;
  }

  h2 {
    font-size: 1.8rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  .step-indicator {
    font-size: 1.05rem;
  }

  label {
    font-size: 1.5rem;
  }

  input {
    font-size: 1.5rem;
  }

  button {
    font-size: 1.5rem;
  }

  .error-message {
    font-size: 1.25rem;
  }

  p {
    font-size: 1.25rem;
  }
}
</style>
